package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
data class AssetRevision(
    val revisionNumber: Int,
    val prompt: String,
    val luauCode: String? = null,
    val payloadUrl: String? = null,
    val timestamp: Long = 0L,
    val metadata: Map<String, String> = emptyMap(),
    val files: List<ProjectFile> = emptyList(),
    val referenceImages: List<String> = emptyList()
)

@Serializable
data class AssetResponse(
    val id: String,
    val status: GenerationStatus,
    val assetType: AssetType,
    val prompt: String,
    val payloadUrl: String? = null,
    val luauCode: String? = null,
    val errorMessage: String? = null,
    val metadata: Map<String, String> = emptyMap(),
    val timestamp: Long = 0L,
    val revisions: List<AssetRevision> = emptyList(),
    val files: List<ProjectFile> = emptyList(),
    val chatHistory: List<ChatMessage> = emptyList(),
    val referenceImages: List<String> = emptyList(),
    val usedProviderId: String? = null,
    val animationKeyframes: String? = null
)

@Serializable
data class CancelAssetResponse(
    val success: Boolean,
    val assetId: String
)@Serializable
data class DeleteAssetResponse(
    val success: Boolean,
    val assetId: String
)
